import React from "react";
import { Container } from "react-bootstrap";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import configServ from "../../services/config"; // Replace with your actual service
import toast from "react-hot-toast";
import EmailConfigurationCard from "./EmailConfigurationCard";
import EmailConfigurationTable from "./EmailConfigurationTable";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const EmailConfigurationPage = () => {
  //#region
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState([]);
  const { company_id } = useSelector((state) => state.GlobalVariables);

  const handlePopup = () => {
    setIsCreate(!isCreate); // Toggles the visibility of the MenuCard
    setIsEdit(false);
  };

  const handleEditData = (data) => {
    setIsEdit(true);
    setIsCreate(true);
    setEditData(data);
  };
  const fetchEmaiConfiguration = async () => {
    setLoading(true);
    try {
      const res = await configServ.getEmailConfigurationsByCompany({company_id:company_id});
      if (res.status === 200) {
        setEmail(res.data || []);
      } else {
        setEmail([]);
        toast.error("Failed to fetch menu list.");
      }
    } catch (e) {
      toast.error("An error occurred!");
      console.log(e);
      setEmail([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmaiConfiguration();
  }, []);

  //#endregion
  return (
    <Container>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Email Configuration"}
        handlePopup={handlePopup}
        create={isCreate}
        isEdit={isEdit}
        setEditData={setEditData}
      />

      <AnimatePresence>
        {isCreate && (
          <EmailConfigurationCard
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            editData={editData}
            // clear={clear}
            isCreate={isCreate} // State passed as a prop
            setIsCreate={setIsCreate} // Function passed as a prop
            fetchEmaiConfiguration={fetchEmaiConfiguration}
          />
        )}
      </AnimatePresence>
      <EmailConfigurationTable
        handleEditData={handleEditData}
        loading={loading} // Pass the loading state
        email={email}
        
      />
    </Container>
  );
};

export default EmailConfigurationPage;
